import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "image-tagger" }
const _hoisted_2 = ["src"]

import { computed, onMounted, ref } from 'vue'
import axios from 'axios'
import { notification } from 'ant-design-vue'
import MediaItem, { Tag } from '@/types/mediaItem'

interface Props {
  visible:boolean
  disabled:boolean
  file:MediaItem
  surveyId:number|null
  surveyAnswerId:number|null
  taggedMediaId:number|null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MediaLocationTagger',
  props: {
    visible: { type: Boolean },
    disabled: { type: Boolean },
    file: null,
    surveyId: null,
    surveyAnswerId: null,
    taggedMediaId: null
  },
  emits: ['tagSaved', 'closeTagger'],
  setup(__props: any, { emit }) {

const props = __props as {
  visible:boolean
  disabled:boolean
  file:MediaItem
  surveyId:number|null
  surveyAnswerId:number|null
  taggedMediaId:number|null
};




const loading = ref(false)

const file = ref<MediaItem|null>(null)
const newTag = ref<Tag>({ position: { x: 0, y: 0 }, survey_id: null, survey_answer_id: null, tagged_media_id: null })

const tags = ref<Tag[]>([])

onMounted(() => {
  file.value = props.file
  tags.value = props.file.tags
  newTag.value.survey_id = props.surveyId
  newTag.value.survey_answer_id = props.surveyAnswerId
  newTag.value.tagged_media_id = props.taggedMediaId
})

function setPin (event:MouseEvent|null = null) : void {
  if (event && canAddTag.value) {
    const target = event.target as Element
    const rect = target.getBoundingClientRect()
    newTag.value.position.x = ((event.clientX - rect.left) / rect.width) * 100
    newTag.value.position.y = ((event.clientY - rect.top) / rect.height) * 100
  }
}

function addPin () : void {
  loading.value = true
  axios.post(process.env.VUE_APP_API_URL + '/surveys/' + newTag.value.survey_id + '/media/tag/' + file.value?.id, { tag: newTag.value }).then((r) => {
    file.value = r.data.data
    closeTagger()
  }).catch(() => {
    notification.error({ message: 'Tag NIET aangemaakt!', description: 'Tag NIET aangemaakt. Probeer het later nogmaals.', duration: 0 })
  }).finally(() => {
    loading.value = false
  })
}

function closeTagger () : void {
  emit('closeTagger', file.value)
}

const canAddTag = computed(() => {
  return !tags.value.some((tag: Tag) => tag.tagged_media_id === props.taggedMediaId) && !props.disabled
})

return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    title: `Tag ${_unref(canAddTag) ? 'toevoegen' : 'bekijken'}`,
    visible: props.visible,
    onCancel: closeTagger
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_a_button, { onClick: closeTagger }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(canAddTag) ? 'Annuleren' : 'Sluiten'), 1)
        ]),
        _: 1
      }),
      (_unref(canAddTag))
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            type: "primary",
            loading: loading.value,
            disabled: loading.value,
            onClick: addPin
          }, {
            default: _withCtx(() => [
              _createTextVNode("Tag opslaan")
            ]),
            _: 1
          }, 8, ["loading", "disabled"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_row, { gutter: [16,16] }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "image-container",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (setPin($event)))
                }, [
                  _createElementVNode("img", {
                    src: file.value?.url
                  }, null, 8, _hoisted_2),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag, index) => {
                    return (_openBlock(), _createBlock(_component_a_tooltip, {
                      placement: "top",
                      key: index,
                      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                    }, {
                      title: _withCtx(() => [
                        _createTextVNode("Foto #" + _toDisplayString(tag.tagged_media_id), 1)
                      ]),
                      default: _withCtx(() => [
                        (tag.tagged_media_id === newTag.value.tagged_media_id)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "tag",
                              style: _normalizeStyle({ left: `calc(${tag.position.x}%)`, top: `calc(${tag.position.y}%)` })
                            }, null, 4))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  (newTag.value.position.x && newTag.value.position.y)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "tag",
                        style: _normalizeStyle({ left: `calc(${newTag.value.position.x}%)`, top: `calc(${newTag.value.position.y}%)` })
                      }, null, 4))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["title", "visible"]))
}
}

})